import { Component, EventEmitter, inject, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { FormsModule } from '@angular/forms';
import * as _ from 'lodash';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { Footer, PrimeTemplate } from 'primeng/api';
import { DialogModule } from 'primeng/dialog';
import { DropdownModule } from 'primeng/dropdown';
import { MultiSelectModule } from 'primeng/multiselect';
import { TooltipModule } from 'primeng/tooltip';

import { UserActivitiesService } from '../user-activities.service';

declare var $: any;

@Component({
    selector: 'activity-statePop',
    templateUrl: 'activity-statePopup.component.html',
    standalone: true,
    imports: [DialogModule, PrimeTemplate, TooltipModule, DropdownModule, FormsModule, MultiSelectModule, Footer, TranslateModule]
})
export class ActivityStatePopUpComponent implements OnInit {
  private router = inject(Router);
  private service = inject(UserActivitiesService);
  private translate = inject(TranslateService);


  activities: any[];
  typologyList: any[];
  selectedTypologies = [];

  state: string;
  status: string;

  typterm: string;

  data: any;
  display: boolean = false;

  periodOptions: any;

  @Input() params: any;
  @Input() idx: number;
  @Output() closepopup: EventEmitter<boolean> = new EventEmitter();
  @Output() saveData: EventEmitter<{ params: any, indx: number }> = new EventEmitter();

  /** Inserted by Angular inject() migration for backwards compatibility */
  constructor(...args: unknown[]);

  constructor() {

    this.periodOptions = [
      { name: this.translate.instant('widgets.party-activities.Week'), value: 'Week' },
      { name: this.translate.instant('widgets.party-activities.Day'), value: 'Day' },
      { name: this.translate.instant('widgets.party-activities.Month'), value: 'Month' }
    ];

  }

  ngOnInit(): void {
    this.state = "All";
    this.data = "Week";

    if (this.params) {
      if (this.params.date)
        this.data = this.params.date;
    }

    this.service
      .getActivityTypologies()
      .subscribe(typ => {
        this.typologyList = typ;
        // TODO:  CONTROLLO TIPOLOGIE CHE ARRIVANO DAI PARAMS
      });

    this.display = true;
  }

  getData(name: string) {
    return 'widgets.party-activities.' + name;
  }

  getState(state: string) {
    return 'widgets.party-activities.' + state;
  }

  cancel() {
    this.closepopup.next(true);
  }

  clearDefault() {
    this.state = "All";
    this.data = "Week";

    this.service
      .getActivityTypologies()
      .subscribe(typ => {
        this.typologyList = typ;
        this.selectedTypologies = [];
      })
  }

  stateChange(state: string) {
    this.state = state;
  }

  confirm() {
    let typologies = null;

    if (this.selectedTypologies.length > 0)
      typologies = this.selectedTypologies;

    let parms = {
      state: this.state,
      date: this.data,
      typologies: typologies
    }

    this.saveData.next({ params: parms, indx: this.idx });
    this.display = false;
    this.closepopup.next(true);
  }

  typoChange(event: boolean, typ: any) {
    if (event) {
      this.selectedTypologies.push(typ);
    }
    else {
      let indx = this.selectedTypologies.indexOf(typ);
      if (indx! = -1)
        this.selectedTypologies.splice(indx, 1);
    }
  }

  removeSelected(typ: any) {

    this.typoChange(false, typ);

    this.typologyList.forEach(t => {
      if (typ.id == t.id)
        t.selected = false;
    })
  }
}
